import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, ArrowUpRight } from "lucide-react";
import { Reveal, RevealLine } from "../lib/motion";
import { sendContact } from "../lib/api";

const initial = { name: "", email: "", company: "", subject: "", message: "" };

export const Contact = ({ onBook }) => {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendContact(form);
      toast.success("Messaggio inviato. Ti risponderemo presto.");
      setForm(initial);
    } catch {
      toast.error("Invio non riuscito. Riprova.");
    }
    setLoading(false);
  };

  return (
    <section id="contatti" data-testid="contact-section" className="py-24 sm:py-32 bg-[var(--paper-2)]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <div className="overline mb-6">Contatti</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)] mb-8">
            <RevealLine>Parliamo del</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--petrol)]">tuo prossimo passo.</RevealLine>
          </h2>
          <Reveal delay={0.15}>
            <p className="text-lg text-[var(--ink-soft)] mb-8">Scrivimi per collaborazioni di advisory, speaking o partnership. Per una consulenza dedicata, prenota direttamente una Executive Call.</p>
            <a href="mailto:gabriellaritondo@gmail.com" className="inline-flex items-center gap-3 text-[var(--petrol)] link-underline">
              <Mail size={18} strokeWidth={1.5} /> gabriellaritondo@gmail.com
            </a>
            <div className="mt-6">
              <button data-testid="contact-book-btn" onClick={onBook}
                className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--accent)] link-underline">
                Prenota una Executive Call <ArrowUpRight size={16} strokeWidth={2} />
              </button>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <form onSubmit={submit} className="space-y-4 bg-white border border-[var(--line)] p-8 sm:p-10">
            <div className="grid sm:grid-cols-2 gap-4">
              <input data-testid="contact-name" placeholder="Nome*" required value={form.name} onChange={set("name")} className="border border-[var(--line)] px-4 py-3 text-sm focus:border-[var(--petrol)] outline-none" />
              <input data-testid="contact-email" type="email" placeholder="Email*" required value={form.email} onChange={set("email")} className="border border-[var(--line)] px-4 py-3 text-sm focus:border-[var(--petrol)] outline-none" />
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <input data-testid="contact-company" placeholder="Azienda" value={form.company} onChange={set("company")} className="border border-[var(--line)] px-4 py-3 text-sm focus:border-[var(--petrol)] outline-none" />
              <input data-testid="contact-subject" placeholder="Oggetto" value={form.subject} onChange={set("subject")} className="border border-[var(--line)] px-4 py-3 text-sm focus:border-[var(--petrol)] outline-none" />
            </div>
            <textarea data-testid="contact-message" placeholder="Il tuo messaggio*" required rows={5} value={form.message} onChange={set("message")} className="w-full border border-[var(--line)] px-4 py-3 text-sm focus:border-[var(--petrol)] outline-none resize-none" />
            <button data-testid="contact-submit" disabled={loading}
              className="btn-fill inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] font-semibold bg-[var(--petrol)] text-white px-8 py-4 disabled:opacity-60">
              {loading ? <Loader2 size={16} className="animate-spin" /> : "Invia messaggio"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
